import type { IStockRepository } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockTransactionEntity } from '@/features/stock/domain/entities/StockEntity.js';

interface Deps { stockRepository: IStockRepository; }

export interface RejectTransactionParams {
  id: string;
  reason: string;
  photos?: string[];
}

export function createRejectTransactionUseCase({ stockRepository }: Deps) {
  return async function rejectTransaction(params: RejectTransactionParams): Promise<StockTransactionEntity | null> {
    const reason = (params.reason ?? '').trim();
    if (!reason) throw new Error('Lý do từ chối là bắt buộc');
    return stockRepository.rejectTransaction({
      id: params.id,
      reason,
      photos: params.photos ?? [],
    });
  };
}
